import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/LegalProductsOnMain.module.scss'

import { Container, Image, Button } from 'react-bootstrap'

class LegalProductsOnMain extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      test: 0
    }
  }

  render() {
    const { products, page_data } = this.props

    return (
      <section className={styles.section}>
        <Container className={styles.container}>
          <h2 className={styles.sectionTitle}>Продукция StomaHelp®</h2>
          <div className={styles.sectionGrid}>
            {products.map( ( product, k ) => (
              <div key={k} className={styles.slyde}>
                <a href={product?.url} className={styles.slyde_image}>
                  <Image src={product?.image} alt={product?.pagetitle} width={164} height={170} />
                </a>
                <div className={styles.slyde_art}>Арт. {product?.article}</div>
                <a href={product?.url} className={styles.slyde_name}>{product?.pagetitle}{product?.longtitle != `` ? `, ${product?.longtitle}.` : ``}</a>
                <a href={product?.url} className={styles.slyde_text}>{product?.introtext}</a>
                <div className={styles.slyde_sep} />
                <Button className={styles.slyde_optproducts} href={page_data?.link_optproducts} variant={`primary`}>Оформить заказ</Button>
                <Button className={styles.slyde_more} href={product?.url} variant={`light`}>Подробнее →</Button>
              </div>
            ))}
          </div>
        </Container>
      </section>
    )
  }
}

LegalProductsOnMain.propTypes = {
  products: PropTypes.array,
  page_data: PropTypes.object
}

LegalProductsOnMain.defaultProps = {
  products: [],
  page_data: {}
}

export default LegalProductsOnMain